(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["QencodeWebRTC"] = factory();
	else
		root["QencodeWebRTC"] = factory();
})(self, function() {
return 